import { render, staticRenderFns } from "./index-home.vue?vue&type=template&id=0b81e9e8&"
import script from "./index-home.vue?vue&type=script&lang=js&"
export * from "./index-home.vue?vue&type=script&lang=js&"
import style0 from "./index-home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports